import { takeEvery, fork, put, call, all } from "redux-saga/effects"

// Login Redux States
import {
  EDIT_PROFILE,
  EDIT_MODE,
  EDIT_PHOTO,
  EDIT_PASSWORD,
  // EDIT_IMPORTANT_ORDER,
} from "./actionTypes"
import {
  profileSuccess,
  profileError,
  editModeSuccess,
  editModeError,
  editPhotoSuccess,
  editPhotoFail,
  editPasswordSuccess,
  editPasswordFail,
  showLoading,
  hideLoading,
} from "./actions"

//Include Both Helper File with needed methods
import {
  updateUserData,
  updateMode,
  updatePhoto,
  updatePassword,
  // updateImportantOrder,
} from "../../helpers/backend_helper"

import { showToast } from "../../components/Toast"

function* editProfile({ payload: { user } }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateUserData, user)
    /** update local storage data **/
    const getLocalStorageProfile = JSON.parse(localStorage.getItem("authUser"))
    const current_success = getLocalStorageProfile.success
    const current_token = getLocalStorageProfile.token
    localStorage.removeItem("authUser")
    const new_arr = {
      result: response,
      success: current_success,
      token: current_token,
    }
    localStorage.setItem("authUser", JSON.stringify(new_arr))
    showToast("Changes applied")
    yield put(profileSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(profileError(error))
  }
}

function* editMode({ payload: { user } }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateMode, user)
    /** update local storage data **/
    const getLocalStorageProfile = JSON.parse(localStorage.getItem("authUser"))
    if (getLocalStorageProfile) {
      // Update the `result.themeMode` value
      getLocalStorageProfile.result.themeMode = response.themeMode;

      // Save the updated object back to localStorage
      localStorage.setItem("authUser", JSON.stringify(getLocalStorageProfile));
      showToast("Changes applied")
      yield put(profileSuccess(response))
      yield put(hideLoading(false))
    }
  } catch (error) {
    yield put(profileError(error))
  }
}

function* onEditPhoto({ payload: employee }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updatePhoto, employee[0])
    /** update local storage data **/
    const getLocalStorageProfile = JSON.parse(localStorage.getItem("authUser"))
    const current_success = getLocalStorageProfile.success
    const current_token = getLocalStorageProfile.token
    localStorage.removeItem("authUser")
    const new_arr = {
      result: response,
      success: current_success,
      token: current_token,
    }
    localStorage.setItem("authUser", JSON.stringify(new_arr))

    yield put(editPhotoSuccess(response))
    showToast("Photo changed")
    yield put(hideLoading(false))
    window.location.reload()
  } catch (error) {
    yield put(editPhotoFail(error))
  }
}

function* onEditPassword({ payload: employee }) {
  yield put(showLoading(true))
  try {
    const response = yield call(updatePassword, employee)
    yield put(editPasswordSuccess(response.data))
    showToast("Password changed")
  } catch (error) {
    const errorMessage = [error.response.data.error]
    yield put(editPasswordFail(errorMessage))
  }
  yield put(hideLoading(false))
}

// function* onEditImportantOrder({ payload: employee }) {
//   try {
//     yield call(updateImportantOrder, employee.user)
//   } catch (error) {
//     const errorMessage = [error.response.data.error]
//   }
// }

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(EDIT_MODE, editMode)
  yield takeEvery(EDIT_PHOTO, onEditPhoto)
  yield takeEvery(EDIT_PASSWORD, onEditPassword)
  // yield takeEvery(EDIT_IMPORTANT_ORDER, onEditImportantOrder)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
